"use client";

import { updateTone, type Settings } from "@/lib/settings-api";

interface Props {
  settings: Settings | null;
  onUpdate: (s: Settings) => void;
}

const TONES = [
  { id: "warm_coach", label: "Warm Coach", desc: "Encouraging and supportive", emoji: "&#129303;" },
  { id: "direct_mentor", label: "Direct Mentor", desc: "Straight to the point", emoji: "&#128640;" },
  { id: "gentle_friend", label: "Gentle Friend", desc: "Soft and understanding", emoji: "&#127796;" },
  { id: "hype_partner", label: "Hype Partner", desc: "Energetic and motivating", emoji: "&#127881;" },
];

export default function ToneSection({ settings, onUpdate }: Props) {
  const handleSelect = async (tone: string) => {
    try {
      const updated = await updateTone(tone);
      onUpdate(updated);
    } catch {
      // Ignore
    }
  };

  return (
    <div
      className="bg-card rounded-2xl border border-border shadow-sm p-4"
      data-testid="settings-tone-section"
    >
      <h2 className="text-sm font-semibold text-text-light mb-3">Coaching Tone</h2>
      <div className="grid grid-cols-2 gap-2">
        {TONES.map((tone) => (
          <button
            key={tone.id}
            onClick={() => handleSelect(tone.id)}
            data-testid={`settings-tone-${tone.id}`}
            aria-pressed={settings?.tone_preference === tone.id}
            className={`p-3 rounded-xl border text-left transition-all ${
              settings?.tone_preference === tone.id
                ? "border-forest bg-forest/5 ring-1 ring-forest/20"
                : "border-border hover:border-border/50 hover:border-primary"
            }`}
          >
            <span className="text-lg" dangerouslySetInnerHTML={{ __html: tone.emoji }} />
            <p className="text-xs font-medium text-text mt-1">{tone.label}</p>
            <p className="text-[10px] text-muted">{tone.desc}</p>
          </button>
        ))}
      </div>
    </div>
  );
}
